import * as React from "react";

const ConnectedUserContext = React.createContext();

const userInitialData = {
  rne: "",
  name: "",
  status: "",
  tel: "",
  email: "",
  password: "",
  confirm_password: "",
};

const keys = {
  token: process.env.REACT_APP_LOCAL_STORAGE_KEY_TOKEN,
  user: process.env.REACT_APP_LOCAL_STORAGE_KEY_USER_DATA,
  firstTime: process.env.REACT_APP_LOCAL_STORAGE_KEY_FIRST_CONNECT,
};

const getItem = (key) => {
  const value = localStorage.getItem(keys[key]);

  if (value) {
    try {
      return JSON.parse(value) || "";
    } catch {
      return null;
    }
  }
  return null;
};

const ConnectedUserContextComponent = ({ children }) => {
  const tokenInitialValue = getItem("token");
  const userInitialValue = getItem("user");
  const FirstTimeInitialValue = getItem("firstTime");

  const [user, setUser] = React.useState(userInitialValue || userInitialData);
  const [token, setToken] = React.useState(tokenInitialValue || null);
  const [isFirstTimeConnect, setisFirstTimeConnect] = React.useState(
    FirstTimeInitialValue || null
  );

  const updateUserData = React.useCallback(() => {
    const data = getItem("user");
    setUser(data || userInitialData);
  }, []);

  const updateUserToken = React.useCallback(() => {
    const tokenData = getItem("token");
    setToken(tokenData);
  }, []);

  const updateisFirstTimeConnectState = React.useCallback(() => {
    const firstTimeData = getItem("firstTime");
    setisFirstTimeConnect(firstTimeData);
  }, []);

  React.useEffect(() => {
    window.addEventListener("storage", () => {
      updateUserData();
      updateUserToken();
      updateisFirstTimeConnectState();
    });
  }, [updateUserData, updateUserToken, updateisFirstTimeConnectState]);

  const updateUser = (data) => {
    localStorage.setItem(keys.user, JSON.stringify(data));
    updateUserData();
  };

  const updateToken = (data) => {
    localStorage.setItem(keys.token, JSON.stringify(data));
    updateUserToken();
  };

  const updateisFirstTimeConnect = (data) => {
    localStorage.setItem(keys.firstTime, JSON.stringify(data));
    updateisFirstTimeConnectState();
  };

  const logout = () => {
    localStorage.removeItem(keys.user);
    localStorage.removeItem(keys.token);
    localStorage.removeItem(keys.firstTime);
    setUser(userInitialData);
    setToken(null);
    setisFirstTimeConnect(null);
  };

  return (
    <ConnectedUserContext.Provider
      value={{
        token,
        user,
        updateUser,
        updateToken,
        logout,
        isFirstTimeConnect,
        updateisFirstTimeConnect,
      }}
    >
      {children}
    </ConnectedUserContext.Provider>
  );
};

const useConnectedUser = () => {
  const {
    token,
    user,
    updateUser,
    updateToken,
    logout,
    isFirstTimeConnect,
    updateisFirstTimeConnect,
  } = React.useContext(ConnectedUserContext);

  return {
    token,
    user,
    updateUser,
    updateToken,
    logout,
    isFirstTimeConnect,
    updateisFirstTimeConnect,
  };
};

export {
  useConnectedUser,
  ConnectedUserContextComponent as ConnectedUserContext,
};
